module.exports = __webpack_public_path__ + "files/nvdm.afbde8e991ea9d164afdaf3fcb228970.pdf";